import React, { useCallback, useEffect, useRef, useState } from "react";
import Breadcrump from "../../components/Breadcrump";
import productAPI from "../../api/productApi";
import ProductCard from "./Card";

function ListPage() {
  const [items, setItems] = useState([]);
  const [totalCount, setTotalCount] = useState("");
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(1);
  const observer = useRef();

   const fetchProducts = async (currentPage) => {
    setLoading(true);

    try {
      const res = await productAPI.listing({
        page: currentPage,
      });

      if (res.data) {
        const { products, pagination } = res.data;

        // 🔥 append instead of replace
        setItems((prev) => [...prev, ...(products || [])]);
        setTotalCount(pagination?.totalCount || 0);
      }
    } catch (err) {
      console.error("Error loading products:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts(page);
  }, [page]);

  // 🔥 Intersection Observer
  const lastItemRef = useCallback(
    (node) => {
      if (loading) return;

      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && items.length < totalCount) {
          setPage((prev) => prev + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading, items, totalCount],
  );




  return (
    <>
      <Breadcrump title="Shop" />

      <section className="s-term-user flat-spacing-25">
        <div className="container">
          {/* <div className="blog-count text-left mb-4">
            Total: <b>{totalCount}</b> categories
          </div> */}

          {items && items.length > 0 && (
            <div className="row  g-4">
              {items.map((item, index) => (
                <div className="col-md-6  col-lg-4  col-sm-6" key={index}>
                  <ProductCard item={item} />
                </div>
              ))}
            </div>
          )}




                 {/* 🔥 Loader */}
          {loading && (
            <div className="text-center mt-4">
              <p>Loading more products...</p>
            </div>
          )}

          {/* End Message */}
          {!loading && items.length >= totalCount && (
            <div className="text-center mt-4">
              <p>✨ You’ve reached the end</p>
            </div>
          )}
        </div>
      </section>
    </>
  );
}

export default ListPage;








// import React, { useEffect, useState, useRef, useCallback } from "react";
// import Breadcrump from "../../components/Breadcrump";
// import productAPI from "../../api/productApi";
// import ProductCard from "./Card";

// function ListPage() {
//   const [items, setItems] = useState([]);
//   const [totalCount, setTotalCount] = useState(0);
//   const [loading, setLoading] = useState(false);

//   const [page, setPage] = useState(1);
//   const observer = useRef();

//   const fetchProducts = async (currentPage) => {
//     setLoading(true);

//     try {
//       const res = await productAPI.listing({
//         page: currentPage,
//       });

//       if (res.data) {
//         const { products, pagination } = res.data;

//         // 🔥 append instead of replace
//         setItems((prev) => [...prev, ...(products || [])]);
//         setTotalCount(pagination?.totalCount || 0);
//       }
//     } catch (err) {
//       console.error("Error loading products:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchProducts(page);
//   }, [page]);

//   // 🔥 Intersection Observer
//   const lastItemRef = useCallback(
//     (node) => {
//       if (loading) return;

//       if (observer.current) observer.current.disconnect();

//       observer.current = new IntersectionObserver((entries) => {
//         if (entries[0].isIntersecting && items.length < totalCount) {
//           setPage((prev) => prev + 1);
//         }
//       });

//       if (node) observer.current.observe(node);
//     },
//     [loading, items, totalCount],
//   );

//   return (
//     <>
//       <Breadcrump title="Shop" />

//       <section className="s-term-user flat-spacing-25">
//         <div className="container">
//           <div className="blog-count text-left mb-4">
//             Total: <b>{totalCount}</b> products
//           </div>

//           <div className="row">
//             {items.map((item, index) => {
//               // last item detect karne ke liye
//               if (index === items.length - 1) {
//                 return (
//                   <div
//                     className="col-md-3"
//                     key={item._id || item.id}
//                     ref={lastItemRef}
//                   >
//                     <ProductCard item={item} />
//                   </div>
//                 );
//               }

//               return (
//                 <div className="col-md-3" key={item._id || item.id}>
//                   <ProductCard item={item} />
//                 </div>
//               );
//             })}
//           </div>

//           {/* 🔥 Loader */}
//           {loading && (
//             <div className="text-center mt-4">
//               <p>Loading more products...</p>
//             </div>
//           )}

//           {/* End Message */}
//           {!loading && items.length >= totalCount && (
//             <div className="text-center mt-4">
//               <p>✨ You’ve reached the end</p>
//             </div>
//           )}
//         </div>
//       </section>
//     </>
//   );
// }

// export default ListPage;